import { parseISO } from 'date-fns';
import { Observable } from 'rxjs';

export class Audit {
  Id: number;
  UserName: string;
  TableName: string;
  Action: string;
  DateTime: Date;
  KeyValues: string;
  OldValues: string;
  NewValues: any;
  // Used only on client side to make the channel mapping a little easier.
  NewChannelGuidValues?: Array<string>;
  // Used only on client side for mapping with the channel names from the channel service
  Channels?: Observable<string[]>;

  constructor(opt?: Partial<Audit>) {
    if (opt) {

      if (opt.DateTime && typeof opt.DateTime === 'string') {
        opt.DateTime = parseISO(opt.DateTime);
      }

      if (opt.NewValues && typeof opt.NewValues === 'string') {
        opt.NewValues = JSON.parse(opt.NewValues);

        let channelPropertyKeyToRemove: string;

        Object.keys(opt.NewValues).forEach(key => {
          if (key.toLowerCase().indexOf('channel') !== -1) {
            const channelProperty = opt.NewValues[key] as Array<any>;
            opt.NewChannelGuidValues = channelProperty?.map(channelObject => {
              const cpKey = Object.keys(channelObject).find(channelObjKey => channelObjKey.toLowerCase().indexOf('termid') !== -1);
              if (cpKey) {
                channelPropertyKeyToRemove = key;
                return channelObject[cpKey];
              }
            });
          }
        });

        if (opt.NewChannelGuidValues?.length > 0 && channelPropertyKeyToRemove) {
          delete opt.NewValues[channelPropertyKeyToRemove];
        }
      }
    }
    Object.assign(this, opt);
  }
}
